import graphql from "babel-plugin-relay/macro";

const DocumentsForReviewQuery = graphql`
  query DocumentsForReviewQuery(
    $after: String
    $first: Int
    $sort: String
    $justMine: Boolean
    $searchQuery: String
    $categories: [Int]
    $daysUntilExpiration: Int
    $includePending: Boolean
  ) {
    documentsToReview(
      q: $searchQuery
      justMine: $justMine
      sort: $sort
      categories: $categories
      daysUntilExpiration: $daysUntilExpiration
      includePending: $includePending
    ) {
      documents(after: $after, first: $first) {
        totalCount
        edges {
          node {
            pk
            name
            category {
              name
            }
            expirationDate
            restricted
            preview
            bloc {
              name
            }
            applicabilityType
            author {
              firstName
              lastName
              title
            }
            cannotBulkReviewReason
            hasPendingChild
          }
        }
      }
      buckets
      showBulkReview
      rssFeedUrl
      categories {
        pk
        name
      }
    }
  }
`;

export default DocumentsForReviewQuery;
